import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useClubSearch } from '../../hooks/useClubSearch';
import Spinner from './spinner/Spinner';

export function getClubSubtitle(club) {
    if (club.typeOfOrg === 'DOMESTIC') {
        return `Football Club · ${club.countryName}`;
    }
    if (club.typeOfOrg === 'NATIONAL') {
        return `National Team · ${club.continentName}`;
    }
    if (club.typeOfOrg === 'COMPANY') {
        return 'Organisation';
    }
}

const SelectWithPicture = ({
    setSelectClub,
    selectClub,
    setTeams,
    setSelectTeam,
    getTeamsBasedOnSelectedClub,
    searchValue,
    setSearchValue,
    setTeamLogo,
    className = '',
    borderColor = '',
    onBlur,
    enabled = true,
    types,
    gender
}) => {
    const [showClubs, setShowClubs] = useState(false);

    const { clubs } = useClubSearch({
        enabled: enabled && !selectClub?.id,
        query: searchValue,
        types,
        gender
    });

    const pickClubLoading = useSelector(
        ({ loading }) => loading.effects.team.getTeamsByClubId
    );

    const handleClubChange = selectedClub => {
        if (setTeamLogo) {
            setTeamLogo(selectedClub?.clubLogoUrl);
        }

        // if the club exists in the state and have ID then get the teams within this club
        if (selectedClub?.id) {
            setSelectClub(selectedClub || {});
            setSearchValue(selectedClub?.clubName || '');
            getTeamsBasedOnSelectedClub !== null &&
                getTeamsBasedOnSelectedClub(selectedClub.id);
        }

        // reset selected teams
        setTeams && setTeams([]);
        setSelectTeam && setSelectTeam({});
    };

    useEffect(() => {
        if (selectClub?.id) {
            setShowClubs(false);
            return;
        }

        if (searchValue.length > 0) {
            setShowClubs(clubs?.length > 0);
        } else {
            setShowClubs(false);
        }
    }, [searchValue, clubs, selectClub]);

    return (
        <>
            <div className='relative'>
                {selectClub?.clubLogoUrl && (
                    <img
                        src={selectClub.clubLogoUrl}
                        alt='Club Logo'
                        className='w-[20px] h-[20px]  absolute left-4 top-1/2 -translate-y-1/2 flex items-center'
                    />
                )}
                <input
                    onChange={event => {
                        setSearchValue(event.target.value);
                        setSelectClub({});
                    }}
                    onBlur={onBlur}
                    className={`${selectClub?.clubLogoUrl ? 'pl-12' : 'pl-4'} ${
                        selectClub?.clubName ? 'pr-10' : 'pr-4'
                    } appearance-none text-[14px] bg-transparent border-b-2 ${borderColor || 'border-gray-600'} w-full text-[#000000] py-4 leading-[24px] focus:outline-none`}
                    type='text'
                    value={selectClub?.clubName || searchValue}
                    aria-label='clubName'
                    placeholder={'Start typing...'}
                />
                {selectClub?.clubName && (
                    <button
                        type='button'
                        onClick={() => {
                            setSelectClub({});
                            setSearchValue('');
                            setTeams && setTeams([]);
                            setSelectTeam && setSelectTeam({});
                        }}
                        className='absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors bg-transparent'
                        aria-label='Clear selection'
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M15 5L5 15M5 5L15 15'
                                stroke='currentColor'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    </button>
                )}
            </div>
            {showClubs && (
                <div
                    className={`absolute z-50 overflow-y-scroll text-[12px] max-h-[35vh] mt-1 bg-white w-full flex flex-col gap-5 rounded-xl ${className} px-4 shadow-2xl`}
                >
                    <ul className=''>
                        {clubs?.map(club => (
                            <li
                                key={club.id}
                                onClick={() => {
                                    handleClubChange(club);
                                    setShowClubs(false);
                                }}
                                className='py-6 border-b-[1px] border-gray-300 flex items-centers'
                            >
                                {pickClubLoading ? (
                                    <Spinner />
                                ) : (
                                    <img
                                        className='w-[32px] h-[32px] mr-4 object-contain'
                                        src={club.clubLogoUrl}
                                        alt=''
                                    />
                                )}
                                <div className='flex flex-col gap-1.5'>
                                    <p className='text-[14px] font-[600] leading-[16px] font-poppins'>
                                        {club?.clubName}
                                    </p>
                                    <p className='text-[11px] font-[400] leading-[16px] font-poppins text-gray-600'>
                                        {getClubSubtitle(club)}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

export default React.memo(SelectWithPicture);
